import type { ApiResponse, PagedResponseDto } from "@/types/common";
import type { NotificationDto, NotificationFilterParams } from "@/types/notification.dto";
import { apiClient, unwrapApiResponse } from "./httpClient";

export const notificationsService = {
  getAdminInbox(filter: NotificationFilterParams = { pageSize: 20 }): Promise<PagedResponseDto<NotificationDto>> {
    return unwrapApiResponse(
      apiClient.get<ApiResponse<PagedResponseDto<NotificationDto>>>("/Notifications/admin", { params: filter }),
    );
  },

  getMyNotifications(filter: NotificationFilterParams = { pageSize: 20 }): Promise<PagedResponseDto<NotificationDto>> {
    return unwrapApiResponse(
      apiClient.get<ApiResponse<PagedResponseDto<NotificationDto>>>("/Notifications/me", { params: filter }),
    );
  },

  markRead(id: number): Promise<boolean> {
    return unwrapApiResponse(apiClient.put<ApiResponse<boolean>>(`/Notifications/${id}/read`));
  },

  markAllRead(): Promise<boolean> {
    return unwrapApiResponse(apiClient.put<ApiResponse<boolean>>("/Notifications/read-all"));
  },
};
